export function mmenu() {

  const mobileMenuHandler = (e) => {
    document.getElementById("mobileNav").style.marginTop = 0;
    document.querySelector("#mobileNav .overlay-content").style.marginBottom = document.querySelector("header .header-inner").offsetHeight;
    
    if(e.currentTarget.classList.contains("open")) {
      document.getElementById("mobileNav").style.height = 0;
    }
    else {
      document.getElementById("mobileNav").style.height = '100%';
    }

    e.currentTarget.classList.toggle("open");
    document.querySelector('header').classList.toggle('menu-open');
    document.querySelector('html, body').classList.toggle("noscroll");
  }
  
  document.addEventListener( 'DOMContentLoaded', function() {
  
    document.querySelector('a[href="#mmenu"]').addEventListener('click', (e) => mobileMenuHandler(e));
  
  });
	
}


// WEBPACK FOOTER //
// ./assets/js/modules/mobile-menu.js